import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, PopoverController, ViewController, App, ModalController, Events} from 'ionic-angular';
import { BillingListPage } from '../billing-list/billing-list';
import { PaymentListPage } from '../payment-list/payment-list';
import { BillingPaymentsProvider } from '../../providers/billing-payments/billing-payments';
import { ToastProvider } from '../../providers/toast/toast';
import { PopoverPage } from '../popover/popover';
import { MakePaymentPage } from '../make-payment/make-payment';
import { LoginProvider } from '../../providers/login/login';
import { BillReportPage } from '../bill-report/bill-report';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-billing-payments',
  templateUrl: 'billing-payments.html',
})

export class BillingPaymentsPage {

  billing = BillingListPage;
  payment = PaymentListPage;
  outstandings = [];
  showData = false;
  index = 0;
  selectedBillType: string;
  selRegistrationLogin : any ;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    private translate: TranslateService,
    private bpProvider: BillingPaymentsProvider, 
    private toast: ToastProvider,
    public popoverCtrl: PopoverController,
    private app: App,
    private modalCtrl: ModalController,
    private login: LoginProvider,
    private events: Events) {
      this.selRegistrationLogin = localStorage.getItem('signup_login')
      
    if(navParams.get("index")){
      this.index = navParams.get("index");
    }
    
  	bpProvider.getOutstandings(1).then(val => {
  		if(val.status == "success"){
        this.outstandings = val.data;
        bpProvider.getBillTypes().then(val => {
          this.showData = true;
        });
  		}else{
        this.showData = true;
  		}
  	}).catch(val => {
      this.showData = true;
    });

    events.subscribe('payment-browser:exit', (val) => {
      this.bpProvider.getOutstandings(0).then(val => {
        if(val.status == "success"){
          this.outstandings = val.data;
        }
      }).catch(err => {
        console.log(err);
      });
    });
  }

  refresh(outstanding:any){
    outstanding.refreshing = true;
    this.bpProvider.getOutstandingBalance(outstanding.id).then(val => {
      if(val.status == "success"){
        outstanding.data.amount = val.data.amount;
      }else{
        outstanding.data = null;
        outstanding.show_bal = false;
        outstanding.message = val.message;
        this.toast.presentToast(val.message);
      }
      outstanding.refreshing = false;
    });
  }

  presentPopover(myEvent) {
    if(this.selRegistrationLogin){
      this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.") 
    }else{
    console.log(this.translate.instant('BILLS'));
    let popover = this.popoverCtrl.create(PopoverPage, {
      parentPage: this,
      options: [
        {
          title: this.translate.instant('BILLS'),
          handler: function(that){
            that.navCtrl.push(BillingListPage);
          }
        },
        {
          title: this.translate.instant('PAYMENT'),
          handler: function(that){
            that.navCtrl.push(PaymentListPage);
          }
        },
        {
          title: this.translate.instant('BILL_REPORT'),
          handler: function(that){
            that.navCtrl.push(BillReportPage);
          }
        },
        {
          title: this.translate.instant('BOUNCED_CHEQUE'),
          handler: function(that){
            that.navCtrl.push(PaymentListPage,{
              type: "RETURNED",
              title: "Bounced cheque"
            });
          }
        },
        {
          title: this.translate.instant('DEBIT_CREDIT_NOTE'),
          handler: function(that){
            that.navCtrl.push(PaymentListPage,{
              type: "DEBIT-CREDIT",
              title: "Debit-Credit note"
            });
          }
        },
      ]
    });
    popover.present({
      ev: myEvent
    });
  }
  }

  onPay(){
    if(this.selRegistrationLogin){
      this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.") 
    }else{
    console.log(this.selectedBillType);
    this.navCtrl.push(MakePaymentPage, {
      billType: this.selectedBillType,
      outstanding: this.outstandings
    });
  }
  }

  setSelectedBillType(billType){
    this.selectedBillType = billType;
  }

  getAmount(amount: number){
    return Math.abs(amount);
  }

  gotoPayments(){
    if(this.selRegistrationLogin){
      this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.") 
    }else{
    this.navCtrl.push(PaymentListPage);    
    }
  }

  gotoBills(){
    if(this.selRegistrationLogin){
      this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.") 
    }else{
    this.navCtrl.push(BillingListPage);
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BillingPaymentsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/billing-payments/billing-payments.ts